module.exports = __webpack_public_path__ + "static/media/12.a859df35.jpg";